import styled from "styled-components";
import Search from "resources/search.png";
import bottomButton from "resources/bottomButton.png";
import webtoonImg from "resources/webtoon.png";
import icnPPT from "resources/icnPPT.png";

export const Container = styled.div`
    width:100%
    position:relative;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction:column;
    margin-bottom:50px;
    @media print {
        margin-top:0;
    } 
`;
export const TopArea = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;

  display: flex;
  justify-content: space-between;
  height: 26px;
  width: 1370px;
`;
export const CounterNav = styled.ul`
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: start;
  // @media only screen and (max-width: 1340px) {
  //     left:5%;
  // }
`;

export const ToolContainer = styled.div`
  display: grid;
  width: 930px;
  grid-template-columns: 250px 400px 280px;
  border: 1px solid #dadce0;
  margin-top: 30px;
  padding: 5px;
  align-items: center;

  @media only screen and (max-width: 1000px) {
  display:none;
  }
}
`;

export const Item = styled.li`
  margin-right: 5px;
  font-size: 14px;
  font-family: var(--hyGothic);
  font-weight: ${(props) => (props.select ? "600" : "400")};
  &.link {
    cursor: pointer;
  }
`;

export const FontContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 335px);
  grid-gap: 10px;

  @media print {
    grid-template-columns: repeat(4, 167px);
  }
  
  @media only screen and (max-width: 1340px) {
      grid-template-columns: repeat(3, 335px);
  }
  @media only screen and (max-width: 1020px) {
      grid-template-columns: repeat(2, 335px);
  }
  @media only screen and (max-width: 810px) {
      grid-template-columns: repeat(1, 335px);
  }
`;

export const WebtoonButton = styled.img.attrs({
  src: webtoonImg,
})`
  margin-top: 5px;
  display: inline-block;
  cursor: pointer;
`;

export const Divider = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-family: var(--hyGothic);
  font-weight: 400;
`;

export const PDFDownButton = styled.div`
  margin-top: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 105px;
  height: 22px;
  /*margin-right:10px;*/
  color: #00bcd4;
  font-size: 12px;
  font-weight: 600;
  font-family: hy1148100116;
  cursor: pointer;
  svg {
    fill: #2ec0a9;
  }

  // @media only screen and (max-width: 1340px) {
  //     right:5%;
  // }
`;
export const ButtomButton = styled.img
  `
  width: 39px;
  height: 37px;  
  cursor: pointer;
  position: fixed;
  bottom: 120px;
  right: 95px;
  z-index: 3;
`;

export const PPTButton = styled.div`
  width: 136px;
  height: 90px;
  background-image: url(${icnPPT});
  background-repeat: no-repeat;
  cursor: pointer;
  position: fixed;
  bottom: 187px;
  right: 43px;
  z-index: 99;
`;

export const SearchBox = styled.form`
  position: relative;
  width: 250px;
  /*height:60px;*/
  padding: 9px;
  display: grid;
  margin: 0 auto;
  grid-template-columns: 1fr 200px;
  z-index: 0;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 100%;
    top: 140px;
  }
  @media only screen and (max-width: 500px) {
    top: 172px;
  }
`;

export const ComboWrapper = styled.div`
  /*display: flex;
  overflow: hidden; */
  align-items: center;
  width: 90%;
  font-family: var(--hyGothic);
`;
export const Combo = styled.select`
  width: 95%;
  magin: 20px;
  height: 100%;
  /*background-color:var(--headerBgColor);*/
  border: none;
  color: black;
  font-family: HYgothicL;
  font-size: 16px;
  padding: 3px;

  /*
    &:focus{
        outline:white solid 1px;
    }*/

  &:focus {
    outline: none;
  }

  background-color: #ffffff;
  border: none;
  border-radius: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: auto;
`;

export const Options = styled.option`
  background-color: white;
  color: #575859;
  line-height: 4;
  font-size: 14px;
  border-radius: 0;
  max-width: 100px;
`;

export const Keyword = styled.input`
  font-family: var(--hyGothic);
  width: 200px;
  margin: 0 auto;
  padding: 10px;
  &:focus {
    outline: none;
    background: #eee;
  }
  font-size: 14px;
  border: 1px solid #fff;
  background: #eee;
`;

export const SearchBtn = styled.button`
  position: flex;
  top: 15px;
  left: 5px;
  width: 24px;
  height: 25px;
  background-image: url(${Search});
  border: none;
  background-color: white;
  cursor: pointer;
  outline: 0;
  filter: grayscale(100%);
`;

export const BtnClearKeyword = styled.input`
  position: absolute;
  top: 15px;
  right: 30px;
  font-size: 20px;
  border: none;
  background-color: white;
  outline: 0;
  cursor: pointer;
`;
